import { useSearchParams } from "react-router-dom";

console.log("'ook");

export default function Language() {
	const [searchParams] = useSearchParams()
	const defaultLanguage = "fr"

	function use() {
		const [searchParams] = useSearchParams()

		for (let v of [searchParams.get("language"), navigator.language, defaultLanguage]) {
			if (v) {
				return v.split("-")[0];
			}
		}

		return defaultLanguage;
	}

	const defineLanguage = use()
	const language = [defaultLanguage, "en"].indexOf(defineLanguage) >= 0 ? defineLanguage : defaultLanguage	

	return {
		define: defineLanguage,
		default: defaultLanguage,
		use: language
	}
}